import React from 'react';
import { Paper, Typography, Divider } from '@mui/material';
import './Legend.css';

const Legend: React.FC = () => {
  return (
    <Paper className="legend-container" elevation={1}>
      <Typography variant="subtitle2" fontWeight="bold" className="legend-title">
        Scenario Flow Legend
      </Typography>
      
      <Divider sx={{ my: 1 }} />
      
      <div className="legend-rows-container">
        <div className="legend-row">
          <div className="legend-row-title">
            <Typography variant="body2" fontWeight="medium">
              Phases:
            </Typography>
          </div>
          
          <div className="legend-row-items">
            <div className="legend-item">
              <span className="legend-color-box phase-setup-color"></span>
              <Typography variant="caption">Setup</Typography>
            </div>
            <div className="legend-item">
              <span className="legend-color-box phase-offer-color"></span>
              <Typography variant="caption">Offer</Typography>
            </div>
            <div className="legend-item">
              <span className="legend-color-box phase-application-color"></span>
              <Typography variant="caption">Application</Typography>
            </div>
            <div className="legend-item">
              <span className="legend-color-box phase-processing-color"></span>
              <Typography variant="caption">Processing</Typography>
            </div>
            <div className="legend-item">
              <span className="legend-color-box phase-contracting-color"></span>
              <Typography variant="caption">Contracting</Typography>
            </div>
            <div className="legend-item">
              <span className="legend-color-box phase-contract-color"></span>
              <Typography variant="caption">Contract</Typography>
            </div>
            <div className="legend-item">
              <span className="legend-color-box phase-execution-color"></span>
              <Typography variant="caption">Execution</Typography>
            </div>
            <div className="legend-item">
              <span className="legend-color-box phase-closure-color"></span>
              <Typography variant="caption">Closure</Typography>
            </div>
          </div>
        </div>
        
        <div className="legend-row">
          <div className="legend-row-title">
            <Typography variant="body2" fontWeight="medium">
              Step Status:
            </Typography>
          </div>
          
          <div className="legend-row-items">
            <div className="legend-item">
              <span className="legend-color-box step-mandatory-color"></span>
              <Typography variant="caption">Mandatory</Typography>
            </div>
            <div className="legend-item">
              <span className="legend-color-box step-optional-color"></span>
              <Typography variant="caption">Optional</Typography>
            </div>
            <div className="legend-item">
              <span className="legend-color-box step-disabled-color"></span>
              <Typography variant="caption">Disabled</Typography>
            </div>
          </div>
        </div>
        
        <div className="legend-row">
          <div className="legend-row-title">
            <Typography variant="body2" fontWeight="medium">
              Step Types:
            </Typography>
          </div>
          
          <div className="legend-row-items">
            <div className="legend-item">
              <span className="legend-icon">📄</span>
              <Typography variant="caption">Document</Typography>
            </div>
            <div className="legend-item">
              <span className="legend-icon">🏁</span>
              <Typography variant="caption">Milestone</Typography>
            </div>
            <div className="legend-item">
              <span className="legend-icon">📤</span>
              <Typography variant="caption">Submission</Typography>
            </div>
            <div className="legend-item">
              <span className="legend-icon">🎯</span>
              <Typography variant="caption">Presentation</Typography>
            </div>
            <div className="legend-item">
              <span className="legend-icon">📝</span>
              <Typography variant="caption">Contract</Typography>
            </div>
            <div className="legend-item">
              <span className="legend-icon">✍️</span>
              <Typography variant="caption">Signature</Typography>
            </div>
            <div className="legend-item">
              <span className="legend-icon">💼</span>
              <Typography variant="caption">Offer</Typography>
            </div>
            <div className="legend-item">
              <span className="legend-icon">🔔</span>
              <Typography variant="caption">Notification</Typography>
            </div>
            <div className="legend-item">
              <span className="legend-icon">👁️</span>
              <Typography variant="caption">Review</Typography>
            </div>
            <div className="legend-item">
              <span className="legend-icon">👍</span>
              <Typography variant="caption">Endorsement</Typography>
            </div>
            <div className="legend-item">
              <span className="legend-icon">📋</span>
              <Typography variant="caption">Doc Preparation</Typography>
            </div>
            <div className="legend-item">
              <span className="legend-icon">🔍</span>
              <Typography variant="caption">Application Review</Typography>
            </div>
            <div className="legend-item">
              <span className="legend-icon">🏗️</span>
              <Typography variant="caption">Project Setup</Typography>
            </div>
            <div className="legend-item">
              <span className="legend-icon">📨</span>
              <Typography variant="caption">Questionnaire</Typography>
            </div>
            <div className="legend-item">
              <span className="legend-icon">✅</span>
              <Typography variant="caption">Completion</Typography>
            </div>
            <div className="legend-item">
              <span className="legend-icon">📜</span>
              <Typography variant="caption">Contract Generation</Typography>
            </div>
            <div className="legend-item">
              <span className="legend-icon">✒️</span>
              <Typography variant="caption">Contract Signing</Typography>
            </div>
          </div>
        </div>
        
        <div className="legend-row">
          <div className="legend-row-title">
            <Typography variant="body2" fontWeight="medium">
              Indicators:
            </Typography>
          </div>
          
          <div className="legend-row-items">
            <div className="legend-item">
              <span className="legend-dotted-line"></span>
              <Typography variant="caption">Optional connections</Typography>
            </div>
            <div className="legend-item">
              <span className="legend-add-point"></span>
              <Typography variant="caption">Add phase here</Typography>
            </div>
          </div>
        </div>
      </div>
    </Paper>
  );
};

export default Legend; 